import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Autoplay]);

window.Swiper = SwiperCore;

(() => {
    'use strict';

    const module = {
        init() {
            this.head();
            this.slider();

            this.jackpotAmount();
        },

        head() {
            if ( window.innerWidth > 768 ) return;

            if ( !document.querySelector('.js-header') ) return;
            const header = document.querySelector('.js-header');
            const head = document.querySelector('.js-head');

            header.style.height = `${head.offsetHeight}px`;
        },

        slider() {
            const elems = document.querySelectorAll('.js-slider');
            if ( !elems.length ) return;

            elems.forEach(el => {
                const sl = el.querySelector('.js-sl');

                const prev = el.querySelector('.js-prev');
                const next = el.querySelector('.js-next');
                const pagin = el.querySelector('.js-pagin');
                const autoplay = sl.getAttribute('data-autoplay');

                new Swiper(sl, {
                    slidesPerView: 'auto',
                    loop: true,
                    allowTouchMove: false,
                    autoplay: (autoplay) ? {
                        delay: +autoplay,
                    } : false,
                    navigation: (prev && next) ? {
                        prevEl: prev,
                        nextEl: next,
                        disabledClass: 'is-disabled',
                        lockClass: 'is-lock',
                    } : false,
                    pagination: (pagin) ? {
                        el: pagin,
                        type: 'bullets',
                        bulletActiveClass: 'is-active',
                        bulletClass: 'bullet',
                        currentClass: 'is-current',
                    } : false,
                });
            });
        },

        jackpotAmount() {
            const elems = document.querySelectorAll('[data-jackpot-amount]');
            if ( !elems.length ) return;

            elems.forEach(el => {
                const t = parseInt(el.dataset.jackpotAmount);
                let n = t;
                const i = parseInt(el.dataset.jackpotDelay),
                    a = el.dataset.jackpotLocale,
                    r = el.dataset.jackpotCurrency,
                    o = Date.now();
                let s;
                const m = () => {
                    let t;
                    try {
                        t = (n / 100).toLocaleString(a, {
                            style: "currency",
                            currency: r,
                            currencyDisplay: "narrowSymbol"
                        });
                    } catch (e) {
                        t = (n / 100).toLocaleString(a, {
                            style: "currency",
                            currency: r,
                            currencyDisplay: "code"
                        }).replace("USD", "$");
                    }
                    el.innerText = t;
                };
                window.addEventListener("visibilitychange", () => {
                    document.hidden ? clearTimeout(s) : (n = t + (Date.now() - o) / i,
                    m(), setTimeout(() => requestAnimationFrame(c), i));
                });
                const c = () => {
                    n++, m();
                    const e = o + (n + 1 - t) * i - Date.now();
                    s = setTimeout(() => requestAnimationFrame(c), e);
                };
                setTimeout(() => requestAnimationFrame(c), i);
            });
        },
    };

    document.addEventListener('DOMContentLoaded', () => {
        module.init();
    });
})();
